// extracted by mini-css-extract-plugin
module.exports = {"container":"VIP_StandardAttributeList__container"};